import { createContext } from 'react';

type TourPage = 'dashboard' | 'sharing' | 'category' | 'cardview' | 'datacard' | 'reminders' | 'vault-admin' | 'probate' | 'completed' | null;

export interface TourContextValue {
  isTourActive: boolean;
  currentPage: TourPage;
  startTour: () => void;
  advanceTo: (page: TourPage) => void;
  endTour: () => void;
}

export const TourContext = createContext<TourContextValue>({
  isTourActive: false,
  currentPage: null,
  startTour: () => {},
  advanceTo: () => {},
  endTour: () => {},
});

export type { TourPage };
